import { createContext } from 'react';
const SentrySdkContext = createContext(null);
export default SentrySdkContext;
//# sourceMappingURL=sentry-sdk.js.map